import { Flex } from "@chakra-ui/layout";
import { Heading } from "@chakra-ui/react";
import { Modal } from "antd";
import { useLoading } from "components/GlobalLoading";
import { useLogsConta } from "features/conta/hooks";

import { CloseModalButton } from "components/Button/CloseModalButton";
import TimelineLogs from "components/TimelineLogs";

interface ModalHistoricoContaProps {
  contaId?: string;
  isOpenModal: boolean;
  onClose: () => any;
}

export default function ModalHistoricoConta({
  contaId,
  isOpenModal,
  onClose,
}: ModalHistoricoContaProps) {
  const { data, isFetching } = useLogsConta(contaId);

  useLoading(isFetching);

  return (
    <>
      <Modal
        centered
        destroyOnClose
        width="500px"
        footer={
          <Flex flex={1} justifyContent="end" gap={4}>
            <CloseModalButton
              showBorder={false}
              close={onClose}
              closeModalLabel="Fechar"
            />
          </Flex>
        }
        visible={isOpenModal}
        onCancel={onClose}
      >
        <Flex>
          <Heading mb={4} size="md">
            Histórico
          </Heading>
        </Flex>
        <Flex py="4px" flexDir={"column"}>
          {data?.map((item, key) => (
            <TimelineLogs key={key} data={item} />
          ))}
        </Flex>
      </Modal>
    </>
  );
}
